import { render, staticRenderFns } from "./TheNoSidebarTemplate.vue?vue&type=template&id=7891b386&scoped=true&lang=pug"
import script from "./TheNoSidebarTemplate.vue?vue&type=script&lang=ts"
export * from "./TheNoSidebarTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7891b386",
  null
  
)

export default component.exports